module.exports = __webpack_public_path__ + "media/images/piscine privée-2c73ca8d8ae17cef0f282e61dfbfcc07.svg";